import computeSelectOptionsfromJson from './computeSelectOptionsfromJson';
import selectParamsCorrectionAdapter from './selectParamsCorrectionAdapter';
import soleParameters from '@/domains/scan/data/soleParameters.json';

function buildCorrectionParameters() {
    return selectParamsCorrectionAdapter(computeSelectOptionsfromJson(soleParameters));
}

export default buildCorrectionParameters;
